import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import { Document, Page, pdfjs } from 'react-pdf';

// Required worker for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PolicyViewer = ({ data }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [numPages, setNumPages] = useState(null);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setNumPages(null);
  };

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  const currentPolicy = data[selectedTab];

  return (
    <Box sx={{ width: '100%' }}>
      {/* Tabs */}
      <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          minHeight: 36,
        }}
      >
        {data.map((policy, index) => (
          <Tab
            key={policy.hr_policy_id}
            label={policy.hr_policy_type_name}
            sx={{
              fontSize: { xs: '0.7rem', sm: '0.85rem' },
              minHeight: 36,
              minWidth: 60,
              py: 0,
              px: 1.5,
            }}
          />
        ))}
      </Tabs>

      {/* Document Viewer */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          mt: 2,
        }}
      >
        {currentPolicy ? (
          <Document
            file={`${process.env.REACT_APP_UPLOADS_URL}/${currentPolicy.hr_policy_document_path}`}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<Typography>Loading PDF...</Typography>}
          >
            {Array.from(new Array(numPages), (el, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={Math.min(900, window.innerWidth)} // responsive
              />
            ))}
          </Document>
        ) : (
          <Typography variant="body2" sx={{ mt: 2 }}>
            No document available
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default PolicyViewer;
